import * as React from 'react';
import { styled } from '../theme-provider';
import { useCardContext } from './card';
const StyledCardSection = styled.div.withConfig({ displayName: "StyledCardSection", componentId: "sc-3ap0zt" }) `border-top:1px solid ${({ theme }) => theme.colors.border.default};padding-top:${({ theme, emphasis }) => emphasis === 'small' ? theme.size.static150 : theme.size.static200};display:flex;gap:${({ theme }) => theme.size.static250};flex-wrap:wrap;`;
export const CardSection = ({ children, ariaLabel, ariaUniqueId, isCollapsed = true, }) => {
    const context = useCardContext();
    const { emphasis, type = 'default', setAriaControlsIds, isActive } = context;
    /* this effect is used to create a string out of each collapsed card section's ariaUniqueId
       this is needed for collapsible cards when they are toggled with the keyboard.
    */
    React.useEffect(() => {
        isCollapsed &&
            ariaUniqueId &&
            setAriaControlsIds &&
            setAriaControlsIds((prev) => `${prev === ' ' ? prev.substring(1) : prev} ${ariaUniqueId}`.trim());
    }, [isCollapsed, setAriaControlsIds, ariaUniqueId]);
    const isContentVisible = type === 'default' ||
        type === 'selectable' ||
        !isCollapsed ||
        (type === 'collapsible' && isActive);
    return isContentVisible ? (React.createElement(StyledCardSection, { emphasis: emphasis, "aria-label": ariaLabel, id: ariaUniqueId }, children)) : null;
};
